import { render, staticRenderFns } from "./companyInfo.vue?vue&type=template&id=1f923eba&scoped=true"
import script from "./companyInfo.vue?vue&type=script&lang=js"
export * from "./companyInfo.vue?vue&type=script&lang=js"
import style0 from "./companyInfo.vue?vue&type=style&index=0&id=1f923eba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f923eba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f923eba')) {
      api.createRecord('1f923eba', component.options)
    } else {
      api.reload('1f923eba', component.options)
    }
    module.hot.accept("./companyInfo.vue?vue&type=template&id=1f923eba&scoped=true", function () {
      api.rerender('1f923eba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/companyCustomerManage/companyInfo.vue"
export default component.exports